/* ====================
   Complementary Products Carousel
   ==================== */

document.addEventListener("DOMContentLoaded", function () {
  function initCompSwiper() {
    if (typeof Swiper === "undefined") {
      setTimeout(initCompSwiper, 300);
      return;
    }

    document.querySelectorAll(".comp-swiper-unique").forEach(function (el) {
      const wrapper = el.closest(".complementary-carousel-wrapper");
      if (!wrapper) return;

      // Destroy existing swiper instance if any
      if (el.swiper) {
        el.swiper.destroy(true, true);
      }

      new Swiper(el, {
        slidesPerView: 2, // Default for mobile (under 768px)
        spaceBetween: 16,
        watchOverflow: true,
        breakpoints: {
          // when window width is >= 768px
          768: {
            slidesPerView: 1.2,
            spaceBetween: 16
          }
        },
        navigation: {
          prevEl: wrapper.querySelector(".comp-swiper-prev"),
          nextEl: wrapper.querySelector(".comp-swiper-next"),
          disabledClass: "swiper-button-disabled",
        },
        pagination: {
          el: wrapper.querySelector(".comp-swiper-pagination"),
          clickable: true,
          type: "bullets",
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          },
        },
        scrollbar: false,
        on: {
          init: function () {
            this.pagination.render();
            this.pagination.update();
            this.navigation.update();
          },
          slideChange: function () {
            this.navigation.update();
          },
        },
      });
    });
  }

  initCompSwiper();

  // Re-initialize on Shopify section updates
  if (window.Shopify) {
    document.addEventListener("shopify:section:load", function () {
      setTimeout(initCompSwiper, 100);
    });
  }
});
